<template>
    <!-- <div class="handle-box-search" v-if="is_password">

        <el-row type="flex" justify="center" style="margin-bottom: 20px;">

            <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">密码:</span>
            <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>

        </el-row>

        <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

            <el-progress :percentage="progress_data"></el-progress>
            <i class="el-icon-loading"></i>
            加载中...

        </div>

        <el-row type="flex" justify="center" v-else>

            <el-button @click="add_isShow=!add_isShow">确定</el-button>


        </el-row>



    </div> -->
    <!-- <div class="container" v-else> -->
    <div class="container">



        <div class="handle-box-search">
            <el-button @click="add_isShow=!add_isShow">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="cashierApplyLists">刷新</el-button>

        </div>

        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">




            <el-table-column prop="port" label="端口" width="200">
                <template slot-scope="scope">
                    {{scope.row.port.alias}}
                </template>
            </el-table-column>

            <el-table-column label="公司名称" prop="psReceiverName" min-width="190">
            </el-table-column>

            <el-table-column label="操作时间" prop="insert_time.YmdHis" min-width="130">
            </el-table-column>

            <el-table-column label="操作员" prop="admin_name" min-width="100">
            </el-table-column>

            <el-table-column label="审核状态" min-width="120">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
                        {{scope.row.status.alias}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="驳回原因" prop="remark" min-width="100">
            </el-table-column>

            <el-table-column label="操作" width="280" align="center">
                <template slot-scope="scope">


                    <el-button type="primary" size="mini" margin-right:5px @click="buttonChange(scope.row.psNo,'1') "
                        trigger="click" v-if="scope.row.status.val=='1'">
                        提交信息
                    </el-button>
                    <el-button type="primary" size="mini" margin-right:5px @click="buttonChange(scope.row.psNo,'0')"
                        trigger="click" v-if="scope.row.status.val=='2'||scope.row.status.val=='0'">
                        输入短信验证码
                    </el-button>

                    <el-button type="primary" size="mini" margin-right:5px @click="tableSearch(scope)" trigger="click"
                        v-if="scope.row.status.val!='4' && scope.row.status.val!='6'">
                        查询审核状态
                    </el-button>
                    <el-button type="primary" size="mini" margin-right:5px @click="buttonChange(scope.row.psNo,'1')"
                        trigger="click" v-if="scope.row.status.val=='4'||scope.row.status.val=='6'">
                        信息变更
                    </el-button>
                    <el-button type="primary" size="mini" margin-right:5px @click="buttonChange(scope.row.psNo,'1')"
                        trigger="click"
                        v-if="scope.row.status.val=='5'||scope.row.status.val=='7'||scope.row.status.val=='8'">
                        重新提交
                    </el-button>


                </template>
            </el-table-column>
        </el-table>

        <!-- 添加组件 -->
        <addcashierApply :isShow="add_isShow" @onSubmit="cashierApplyLists"></addcashierApply>
        <!-- 编辑组件 -->
        <editcashierApply :isShow="edit_isShow" :data="psNo" :type="type" @onSubmit="cashierApplyLists">
        </editcashierApply>
        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

    </div>
</template>

<script>
    var _this;
    import addcashierApply from "./addcashierApply.vue";
    import editcashierApply from "./editcashierApply.vue";

    export default {
        components: {
            addcashierApply,
            editcashierApply
        },
        data() {
            return {
                submit_data: {
                    page: 1,
                    export_password: ''
                },
                psNo: '',

                type: '',

                is_password: false,

                search_time: '',
                add_isShow: false,
                edit_isShow: false,

                result_data: [],
                // 存放表格数据
                tableData: [],
                search_data: {
                    page: 1,
                    limit: 10
                },
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }


            };
        },
        created() {
            _this = this;
            _this.cashierApplyLists();

        },

        methods: {

            /* type是自定义的变量，其中输入短信验证码按钮的时候定义type为0，
            进入的详情页面不可以修改数据，不走“分账接收方账户变更申请V2”接口，
            信息变更和重新提交的type为1，进入的页面是可编辑银行信息的页面，
            点击确定按钮走“分账接收方账户变更申请V2”接口*/
            buttonChange(psNo, type) {
                _this.edit_isShow = !_this.edit_isShow;
                _this.psNo = psNo;
                _this.type = type;
            },

            // 单条进件查询(点击列表查询审核状态按钮调用的接口)
            tableSearch(scope) {
                console.log(scope.$index);
                console.log(scope.row.psNo);
                _this
                    .$post('/easy_cashier/cashierAccountApplyQuery', {
                        psNo: scope.row.psNo
                    })
                    .then((res) => {


                        _this.tableData[scope.$index].status = res.data.status;




                    })
                    .catch((err) => { });
            },


            // 获取列表接口
            cashierApplyLists() {
                console.log(111);
                _this
                    .$post('/easy_cashier/cashierApplyLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                        _this.psNo = res.data.psNo;



                    })
                    .catch((err) => { });
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.cashierApplyLists();
            }





        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        max-width: 150px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown+.el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>